/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceInventoryProvider extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceInventoryProvider");
    }

    getFixupPrototypeFunction() { return ResourceInventoryProvider.fixupPrototype; }

    static newInstance(model: Partial<ResourceInventoryProvider>): ResourceInventoryProvider {
        let obj = Object.assign(new ResourceInventoryProvider(), model);
        ResourceInventoryProvider.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceInventoryProvider>): ResourceInventoryProvider {
        if (!model) return null;
        return ResourceInventoryProvider.newInstance(<ResourceInventoryProvider> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceInventoryProvider) {
        if (!obj) return;

        models.ResourceInventoryProvider.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceInventoryProvider): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceInventoryProvider.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Provider owning the resources
     */
    provider: models.InventoryProvider;

}
